import {ChangeDetectionStrategy, Component, OnDestroy, OnInit,} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {AppVersionService} from './core/app-version.service';
import {ServiceWorkerService} from './core/service-worker.service';

@Component({
    standalone: false,
    // tslint:disable-next-line:component-selector
    selector: 'body[root]',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
    private unsubscribe: Subscription[] = [];

    constructor(
        private router: Router,
        private appVersionService: AppVersionService,
        private serviceWorkerService: ServiceWorkerService,
    ) {}

    ngOnInit() {
        this.serviceWorkerService.registerServiceWorker();
        this.appVersionService.checkAndClearCacheIfNeeded().then(() => {});
        const routerSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                // scroll to top on every route change
                window.scrollTo(0, 0);
                // to display back the body content
                setTimeout(() => {
                    document.body.classList.add('page-loaded');
                }, 500);
            }
        });
        this.unsubscribe.push(routerSubscription);
    }
    ngOnDestroy() {
        this.unsubscribe.forEach((sb) => sb.unsubscribe());
    }
}